import { useTranslation } from 'react-i18next';

import type { Client } from '~/api/clients/types';
import type { CalculationData, Line } from '~/api/common/types';

import { Title } from '~/components';

import { getVatRegime } from '../documents.utils';
import { PriceSummary } from '../PriceSummary/PriceSummary';
import { sectionStyle, summaryInnerStyle, summaryStyle } from './documentLines.css';
import { DocumentLinesTable } from './DocumentLinesTable';

type Props = {
  calculationData: CalculationData;
  client: Client | null;
  lines: Line[];
};

export const DocumentLines = ({ calculationData, client, lines }: Props) => {
  const { t } = useTranslation(['invoices']);

  return (
    <section className={sectionStyle}>
      <Title as="h2" styleAs="h3">
        {t('invoices:createEdit.lines.title')}
      </Title>

      <DocumentLinesTable calculationData={calculationData} lines={lines} />

      <div className={summaryStyle}>
        <PriceSummary calculationData={calculationData} className={summaryInnerStyle} vatRegime={getVatRegime(client)} />
      </div>
    </section>
  );
};
